import { toUtcIsoString } from './dateUtils.js'

export function buildVehicleLogExitPayload({ communityId, record, exitTime = new Date() }) {
  const payload = {
    exitTime: toUtcIsoString(exitTime),
  }

  const cid = communityId || record?.communityId || ''
  if (cid) payload.COMMUNITY_ID = cid

  const mode = String(record?.mode || '').toUpperCase()
  if (mode === 'WALK') {
    payload.MODE = 'WALK'
    if (record?.personId) payload.PERSON_ID = record.personId
    if (record?.personName) payload.PERSON_NAME = record.personName
  } else {
    payload.MODE = 'VEHICLE'
    if (record?.vehicleNumber) payload.VEHICLE_NUMBER = record.vehicleNumber
  }

  return payload
}
